<div class="modal">
    <div class="header">
        <h1 class="title">{{ 'MODAL_INACTIVATE_TRANSFER_TITLE' | translate }}</h1>
        <span class="subtitle" *ngIf="!!transfer && !!transfer.title">" {{transfer.title}} "</span>
        <div class="close-button" (click)="close()"></div>
    </div>
    <div class="body">
        <div class="loading-container" *ngIf="(transferDeleting$ | async)">
            <div class="loading-spinner-grey"></div>
        </div>
        <div class="section">
            <div class="description" *ngIf="!(transferDeleting$ | async)">
                {{ 'MODAL_INACTIVATE_TRANSFER_DESCRIPTION_CONFIRMATION' | translate }}
            </div>
        </div>
    </div>
    <div class="footer">
        <button class="btn-new white" type="submit" (click)="close()" [disabled]="(transferDeleting$ | async)"
            translate>PREMIUM_ADMIN_MEMBER_MODAL_ADD_GROUP_BUTTON_LABEL_CANCEL</button>
        <button class="btn-new red" (click)="onConfirmInactivate()" [disabled]="(transferDeleting$ | async)"> {{
            'MODAL_INACTIVATE_TRANSFER_BUTTON_CONFIRM_INACTIVATE_LABEL' | translate }}
        </button>
    </div>
</div>